/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { type MovieRatingValueType, movieRatingValueSchema } from './movie-rating-value-schema';

export const movieRatingDataSchema = z.object({
  watched: z.boolean(),
  watchCount: z.number(),
  wantsToWatch: z.boolean(),
  rating: movieRatingValueSchema.nullable(),
});

export interface IMovieRatingData {
  watched: boolean;
  watchCount: number;
  wantsToWatch: boolean;
  rating: MovieRatingValueType | null;
}
